"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _Icon = _interopRequireDefault(require("web/shared/icons/Icon"));
var _useHoverCycle = _interopRequireWildcard(require("web/shared/icons/useHoverCycle"));
var _AnchoredOverlay = _interopRequireDefault(require("web/shared/components/AnchoredOverlay"));
var _useDelayedTip = _interopRequireDefault(require("web/shared/components/useDelayedTip"));
var _CopyTextButton = require("web/shared/components/CopyTextButton.styles");
var _useCopyText = _interopRequireDefault(require("web/shared/components/useCopyText"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The copy action for one piece of text, such as a URL or a name: the copy
* mark alone, no box, at a card's corner or beside what it copies. A press
* copies the text exactly as given, and the mark turns into the check for a
* moment and back, in the same slot. A deliberate hover, or focus, says what
* it does and shows the whole text above it, in the app's own overlay, which
* places itself where there is room rather than off the edge of a panel.
*/
function CopyTextButton(props) {
  var _props$copy;
  const ownCopy = (0, _useCopyText.default)(props.text);
  const _ref = (_props$copy = props.copy) !== null && _props$copy !== void 0 ? _props$copy : ownCopy,
    copied = _ref.copied,
    genCopy = _ref.genCopy;
  const _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    button = _useState2[0],
    setButton = _useState2[1];
  const tip = (0, _useDelayedTip.default)();
  const pointed = tip.pointed;
  const progress = (0, _useHoverCycle.default)(pointed && !copied, _useHoverCycle.GLYPH_CYCLE_MS);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
      ref: setButton,
      type: "button",
      "aria-label": props.label,
      onClick: event => {
        // A press here is not a click on nothing, so an ancestor that
        // reacts to one must not see it.
        event.stopPropagation();
        void genCopy();
      },
      onMouseEnter: tip.onMouseEnter,
      onMouseLeave: tip.onMouseLeave,
      onFocus: tip.onFocus,
      onBlur: tip.onBlur
    }, stylex.props(_CopyTextButton.styles.copy, copied && _CopyTextButton.styles.copyDone)), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        name: copied ? "checkmark" : "copy",
        size: "xs",
        progress: progress
      })
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AnchoredOverlay.default, {
      anchor: tip.shown ? button : null,
      placement: "auto",
      onDismiss: null,
      role: "tooltip",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_CopyTextButton.styles.tip)), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_CopyTextButton.styles.tipTitle)), {}, {
          children: copied ? "Copied" : props.label
        })), props.text]
      }))
    })]
  });
}
var _default = exports.default = CopyTextButton;